module.exports = __webpack_public_path__ + "static/media/400135_01.2e126027.png";